// extracted by mini-css-extract-plugin
export default {"videoIframe":"VideoIframe_videoIframe__UqI7V","videoIframe__wrapper":"VideoIframe_videoIframe__wrapper__FVgie"};